<template>
  <div class="gs-app gm-add-unsubscriber gs-refresh-controls flex flex-col w-full">
    <div class="gm-add-unsubscriber__tabs flex flex-row border-grey-300 border-b-2">
      <gd-tabs
        :tabs="unsubscribersTabs"
        :current-tab="unsubscribersTab"
        :tab-active-class="'border-primary border-b-2 text-primary gs-default-tabs-item-active'"
        :line-class="'gs-default-tabs-active-line'"
        class="unnsubscribers_create_tab_head"
        @onClick="handleUnsubscribersTabChange"
      />
    </div>
    <VuePerfectScrollbar>
      <div class="scroll-modal-tab">
        <div class="p-6">
          <div v-if="unsubscribersTab === 'copy-paste'" class="relative">
            <div class="flex flex-col mb-6">
              <label class="font-semibold text-sm text-grey-700 mb-2">
                {{ $t('frontend_groovemail_components_suppressions_suppressors_emails') }}
              </label>
              <text-area
                variant="base"
                v-model="model.unsubscribersEmails"
                :placeholder="$t('frontend_groovemail_suppressions_enter_emails_unsubscribers')"
                rows="3"
              />
              <p
                v-if="formSubmitted && !model.unsubscribersEmails.trim()"
                class="text-sm text-danger"
              >
                {{ $t('frontend_groovemail_suppressions_enter_emails_unsubscribers_email_required') }}
              </p>
              <div class="flex items-center text-sm text-grey-700 font-semibold mt-2">
                <span class="fa fa-info-circle mr-1"></span>
                <span>{{ $t('frontend_groovemail_suppressions_emails_suppressors_note') }}</span>
              </div>
            </div>
            <div class="flex flex-col mb-6">
              <label class="font-semibold text-sm text-grey-700 mb-2">
                {{ $t('frontend_groovemail_suppressions_enter_emails_unsubscribers_select_lists') }}
              </label>
              <treeselect
                class="custom-treeselect treeselect-add-new two-items--treeselect-height"
                :class="{
                  'error text-danger': formSubmitted && model.unsubscribedLists && model.unsubscribedLists.length == 0
                }"
                v-model="model.unsubscribedLists"
                :multiple="true"
                :options="listData"
                :clearOnSelect="true"
                :closeOnSelect="true"
                :clearable="false"
                @select="listSelected"
                :placeholder="
                  $t('frontend_groovemail_campains_step3_select_list')
                "
              />
              <p
                v-if="
                  formSubmitted &&
                  model.unsubscribedLists &&
                  model.unsubscribedLists.length == 0
                "
                class="text-sm text-danger"
              >
                {{ $t('frontend_groovemail_suppressions_enter_emails_unsubscribers_list_required') }}
              </p>
            </div>
            <div class="flex flex-col mb-6">
              <label class="font-semibold text-sm text-grey-700 mb-2">
                {{ $t('frontend_groovemail_suppressions_enter_emails_unsubscribers_reason') }}
              </label>
              <text-area
                variant="base"
                v-model="model.unsubscribeReason"
                :placeholder="$t('frontend_groovemail_suppressions_enter_emails_unsubscribers_enter_reason')"
                rows="3"
              />
              <p
                v-if="formSubmitted && !model.unsubscribeReason.trim()"
                class="text-sm text-danger"
              >
                {{ $t('frontend_groovemail_suppressions_enter_emails_unsubscribers_reason_required') }}
              </p>
              <p
                v-if="
                  formSubmitted &&
                  model.unsubscribeReason.trim() &&
                  model.unsubscribeReason.length > 250
                "
                class="text-sm text-danger"
              >
                {{ $t('frontend_groovemail_suppressions_enter_emails_unsubscribers_reason_maxlength') }}
              </p>
            </div>
            <div class="flex justify-end">
              <gs-button
                variant="outline"
                size="md"
                @click="closeUnsubscriberModal()"
                >{{ $t('frontend_cancel') }}</gs-button
              >
              <gs-button
                variant="primary"
                size="md"
                class="ml-2"
                @click="addUnsubscriber()"
              >
                {{ $t('frontend_save') }}</gs-button
              >
            </div>
          </div>
          <div v-if="unsubscribersTab === 'import'" class="relative">
            <div class="text-sm italic">
              {{ $t('frontend_groovemail_components_suppressions_add_unsubscriber_allowed_file_types') }}
            </div>
            <div class="text-sm italic mb-6">
              {{ $t('frontend_groovemail_components_suppressions_add_unsubscriber_file_processing') }}
            </div>
            <div class="flex flex-col mb-6">
              <label class="font-semibold text-sm text-grey-700 mb-2">
                {{ $t('frontend_groovemail_components_suppressions_add_unsubscriber_file_to_upload') }}
                :
              </label>
              <form enctype="multipart/form-data">
                <label
                  class="upload-unsubscriber-btn bg-primary text-primary-invert hover:bg-primary-dark"
                  for="upload-unsubscriber"
                  :style="unsubscriberButtonViaImport"
                >
                  {{ $t('frontend_groovemail_components_suppressions_suppressors_add_unsubscriber_via_import') }}
                </label>
                <input
                  id="upload-unsubscriber"
                  type="file"
                  accept=".csv"
                  @change="onFileChange"
                />
              </form>
            </div>
            <div class="flex flex-col items-start mb-6">
              <label class="font-semibold text-sm text-grey-700 mb-2">
                {{ $t('frontend_groovemail_components_suppressions_add_unsubscriber_download_sample') }}
                :
              </label>
              <gs-button
                variant="outline"
                size="md"
                @click="downloadSampleForAddingUnsubscriber()"
              >
                <span>
                  {{ $t('frontend_groovemail_admin_block_sample_file') }}
                  <span class="fa fa-download ml-2" aria-hidden="true"></span>
                </span>
              </gs-button>
            </div>
            <div class="flex flex-col items-start">
              <label class="font-semibold text-sm text-grey-700 mb-2">
                {{ $t('frontend_groovemail_components_suppressions_add_unsubscriber_download_lists_for_ids') }}
              </label>
              <gs-button
                variant="outline"
                size="md"
                @click="downloadListsForIds()"
              > 
                <span>
                  {{ $t('frontend_list_download_button_text')}}
                  <span class="fa fa-download ml-2" aria-hidden="true"></span>
                </span>
              </gs-button>
            </div>
          </div>
        </div>
      </div>
    </VuePerfectScrollbar>
    <gd-modal
      name="create-maillist-in-form-modal"
      :title="$t('frontend_groovemail_contacts_step4_create_new_list')"
    >
      <create-list
        :type="'add'"
        :mail_list_id="null"
        :mail_list_data="mailListData"
        @showLoader="showLoader"
        @hideLoader="hideLoader"
        @fetchEventsList="fetchEventsList"
        @closeCreateMaillistModal="closeCreateMaillist"
      >
      </create-list>
    </gd-modal>

    <!-- Confirmation import csv -->
    <confirm-modal
      :ref="`confirmation-import-csv`"
      :name="`confirmation-import-csv`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_suppressions_are_you_sure_upload')"
      @confirm="confirmFileChnage"
      @close="closeFileChnageConfirm"
    />
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { getData , postData} from '@/utils/apiHelper.js';
import { listUrls, suppressorsUrl } from '@/utils/urls.js';
import CreateList from '@/components/create-lists.vue';
import downloadCsvFile from '@/components/downloadCsvFile.js';

import { showRequestErrorAlert } from '@/components/showDialog.js';

export default {
  data() {
    return {
      lists: [],
      unsubscribersTab: 'copy-paste',
      unsubscribersEmailsData: [],
      model: {
        unsubscribersEmails: '',
        unsubscribedLists: [],
        unsubscribeReason: '',
      },
      formSubmitted: false,
      mailListData: { name: '', description: '' },
      confirmFileTarget: null,
    };
  },

  components: {
    Treeselect,
    VuePerfectScrollbar,
    CreateList,
  },

  watch: {
    // Removes the "Create New List" option from the unsubscribedLists array
    'model.unsubscribedLists': function removeCreateListOption() {
      if (this.model.unsubscribedLists && this.model.unsubscribedLists.length) {
        const listIndex = this.model.unsubscribedLists.findIndex((ele) => {
          return ele === 'createListOption1';
        });
        if (listIndex >= 0) {
          this.model.unsubscribedLists.splice(listIndex, 1);
        }
      }
    },
  },

  methods: {
    // It is used to fetch lists data
    async fetchListsData() {
      try {
        const listData = await getData(listUrls.list);
        this.lists = listData?.data?.data;
      } catch (error) {
        // show error alert
        showRequestErrorAlert(error?.response?.data?.error);
      }
    },

    /**
     * Triggered opening modal for creation of list on selecting last option.
     * @param {object} node respresents list node
     */
    listSelected(node) {
      if (node.id === 'createListOption1') {
        this.openCreateListModal();
      }
    },

    // It is used to open modal for creating new list.
    openCreateListModal() {
      this.mailListData.name = '';
      this.mailListData.description = '';
      this.$root.$emit('modal-open', 'create-maillist-in-form-modal');
    },

    // It is used to close modal for creating new list.
    closeCreateMaillist() {
      this.$root.$emit('modal-close', 'create-maillist-in-form-modal');
    },

    /**
     * Used to fetch lists data and set the last created last as option.
     * @param {object} listData recently created list
     */
    async fetchEventsList(listData) {
      await this.fetchListsData();
      if (listData && listData.data && listData.data.id) {
        this.model.unsubscribedLists.push(listData.data.id);
      }
    },

    // Download user lists with Id
    async downloadListsForIds() {
      const paramsData = {
        download: 1,
      };
      await downloadCsvFile(listUrls.list, { params: paramsData }, 'list.csv');
    },

    // Download sample file for adding unsubscriber
    async downloadSampleForAddingUnsubscriber() {
      await downloadCsvFile(
        suppressorsUrl.sampleUnsubscribersCsvDownload,
        null,
        'unsubscribers.csv'
      );
    },

    // It is used to upload suppression data.
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;

      // set the file target
      this.confirmFileTarget = files;

      if (!files.length) return;

      // open the modal
      this.$refs[`confirmation-import-csv`].open();
    },
    
    // confirm file change
    async confirmFileChnage() {
      // If file is not of csv type, return
      const formData = new FormData();
      formData.append('csv', this.confirmFileTarget[0]);
      
      try {
        await postData(suppressorsUrl.uploadUnsubscribersCsv, formData);
      } catch (error) {
        // show error alert
        showRequestErrorAlert(error?.response?.data?.error);
      }

      // Refresh the listing
      this.$emit('refreshUnsubscribersListing');

      // Close the modal
      document.getElementById('upload-unsubscriber').value = '';
      this.$emit('closeUnsubscribersModal');
    },

    // close confirm file change
    closeFileChnageConfirm() {
      this.confirmFileTarget = null;
    },

    /**
     * Triggered on change of tab.
     * @param {string} newTab new tab
     */
    handleUnsubscribersTabChange(newTab) {
      this.unsubscribersTab = newTab;
    },

    // Used to add new unsubscriber manually
    async addUnsubscriber() {
      this.formSubmitted = true;
      if (
        this.model.unsubscribersEmails.trim() &&
        this.model.unsubscribedLists &&
        this.model.unsubscribedLists.length &&
        this.model.unsubscribeReason.trim() &&
        this.model.unsubscribeReason.length <= 250
      ) {
        const unsubscriberData = this.model.unsubscribersEmails.trim();
        const splitted = unsubscriberData.split('\n');
        splitted.forEach((element) => {
          if (element.trim()) {
            this.unsubscribersEmailsData.push(element.trim().toLowerCase());
          }
        });
        const payload = {
          unsubscribe_list: this.model.unsubscribedLists,
          emails: this.unsubscribersEmailsData,
          reason: this.model.unsubscribeReason,
        };

        try {
          await postData(suppressorsUrl.unsubscribers, payload);
          this.$emit('closeUnsubscribersModal');
          this.$emit('refreshUnsubscribersListing');
          this.model.unsubscribersEmails = '';
          this.model.unsubscribedLists = [];
          this.model.unsubscribeReason = '';
          this.unsubscribersEmailsData = [];
        } catch (error) {
          // show error alert
          showRequestErrorAlert(error?.response?.data?.error);
        }
      }
    },

    // Emitted event for closing unsubscriber modal
    closeUnsubscriberModal() {
      this.$emit('closeUnsubscribersModal');
    },

    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },
  },

  computed: {
    /**
     * Returns tabs data.
     * @return {array} - unsubscribers tabs
     */
    unsubscribersTabs() {
      return [
        {
          title: `<span class="text-sm font-semibold">&nbsp;${this.$t(
            'frontend_groovemail_suppressions_unsubscribers_add_via_copy_paste'
          )} <span>`,
          value: 'copy-paste',
        },
        {
          title: `<span class="text-sm font-semibold">&nbsp;${this.$t(
            'frontend_groovemail_suppressions_unsubscribers_add_via_copy_upload'
          )} <span>`,
          value: 'import',
        },
      ];
    },

    /**
     * Returns list data to be fed into treeselect.
     * @return {array} - array containing modified list data
     */
    listData() {
      const listData = [];
      if (this.lists && this.lists.length) {
        this.lists.forEach((element) => {
          if (element.is_default !== 1) {
            listData.push({ id: element.id, label: element.name });
          }
        });
      }
      const listIndex = listData.findIndex((listEle) => {
        return listEle.id === 'createListOption1';
      });
      if (listIndex < 0) {
        listData.push({
          id: 'createListOption1',
          label: this.$t('frontend_groovemail_mail_list_newlist'),
        });
      }
      return listData;
    },

    /**
     * Returns styling for unsubcriber import button.
     * @return {object} - styling of button.
     */
    unsubscriberButtonViaImport() {
      return {
        '--import-email-text': this.$t(
          'frontend_groovemail_components_suppressions_suppressors_add_unsubscriber_via_import'
        ),
      };
    },
  },

  // Triggers API call to fetch lists data
  async created() {
    await this.fetchListsData();
  },
};
</script>

<style lang="scss">
#upload-unsubscriber {
  opacity: 0;
  position: absolute;
  z-index: -1;
}

.upload-unsubscriber-btn {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  display: inline-block;
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  border-radius: 6px;
  outline: 0;
  position: relative;
  font-size: 16px;
  text-align: center;
  padding: 0 16px;
  
  &:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
      0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  
  &:after {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    content: var(--import-email-text) !important;
  }
}

.two-items--treeselect-height {
  .vue-treeselect__menu-container {
    .vue-treeselect__list {
      max-height: 114px !important;
    }
  }
}
</style>

<style scoped>
.gm-add-unsubscriber {
  min-width: 0;
  color: var(--gs-foreground);
  background: var(--gs-surface);
}

.gm-add-unsubscriber__tabs {
  min-width: 0;
  padding: 0 20px;
  background: var(--gs-surface-subtle);
}

.gm-add-unsubscriber .scroll-modal-tab {
  min-width: 0;
}

@media (max-width: 640px) {
  .gm-add-unsubscriber__tabs {
    padding: 0 14px;
  }

  .gm-add-unsubscriber .scroll-modal-tab > div {
    padding: 18px 14px;
  }

  .gm-add-unsubscriber .flex.justify-end {
    flex-wrap: wrap;
    gap: 8px;
  }
}
</style>
